import { render, staticRenderFns } from "./SupportBlocks.vue?vue&type=template&id=778ff10c&scoped=true&"
import script from "./SupportBlocks.vue?vue&type=script&lang=js&"
export * from "./SupportBlocks.vue?vue&type=script&lang=js&"
import style0 from "./SupportBlocks.vue?vue&type=style&index=0&id=778ff10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778ff10c",
  null
  
)

export default component.exports